import React from "react";
// ANT DESIGN COMPONENTS
import { Button, Radio } from "antd";
import type { RadioChangeEvent } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faSave } from "@fortawesome/free-solid-svg-icons";
// INTERFACES
import { BanksFloorConfigurationHeaderInterface } from "../../../interfaces/Bank.interface";

function BanksFloorConfigurationHeader({
	bankName,
	startFloorNumber,
	disableStartFloorNumberSelection,
	onClickRefreshPage,
	onClickSave,
	onChangeStartFloorNumber,
}: BanksFloorConfigurationHeaderInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChange = (checked: boolean) => {
		onChangeStartFloorNumber(checked);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='generalStyles__pageHeader' style={{ display: "flex", justifyContent: "space-between" }}>
			<div>
				<div className='generalStyles__flex'>
					{" "}
					<h5 className='generalStyles__info'>{bankName}</h5>
				</div>
			</div>
			<div>
				<div className='generalStyles__flexEnd '>
					<div>
						<Radio.Group
							value={startFloorNumber ? 1 : 0}
							disabled={disableStartFloorNumberSelection}
							onChange={(e: RadioChangeEvent) => onChange(e.target.value === 1)}
						>
							<Radio value={0}>position start from 1</Radio>
							<Radio value={1}>position start from 0</Radio>
						</Radio.Group>
					</div>
					<div>
						<Button
							className='buttonStyle__8 generalStyles__width150px generalStyles__mlFix'
							onClick={onClickRefreshPage}
							icon={<FontAwesomeIcon icon={faArrowsRotate} className='generalStyles__mrFix' />}
						>
							{t("general.refreshPage")}
						</Button>
					</div>
					<div>
						<Button
							icon={<FontAwesomeIcon className='generalStyles__mrFix' icon={faSave} />}
							className='buttonStyle__17 generalStyles__width150px generalStyles__mlFix'
							onClick={onClickSave}
						>
							{t("general.save")}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default BanksFloorConfigurationHeader;
